module.exports = __webpack_public_path__ + "img/airhelp@2x.cb8632b.png";